var _slicedToArray = require("C:/vagrant_tienda/apache/kinedu-educators-landing/node_modules/@babel/runtime/helpers/slicedToArray");

var _taggedTemplateLiteral = require("C:/vagrant_tienda/apache/kinedu-educators-landing/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2;

module.exports = function (e) {
  var t = {};

  function o(r) {
    if (t[r]) return t[r].exports;
    var n = t[r] = {
      i: r,
      l: !1,
      exports: {}
    };
    return e[r].call(n.exports, n, n.exports, o), n.l = !0, n.exports;
  }

  return o.m = e, o.c = t, o.d = function (e, t, r) {
    o.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: r
    });
  }, o.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, o.t = function (e, t) {
    if (1 & t && (e = o(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var r = Object.create(null);
    if (o.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var n in e) {
      o.d(r, n, function (t) {
        return e[t];
      }.bind(null, n));
    }
    return r;
  }, o.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return o.d(t, "a", t), t;
  }, o.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, o.p = "", o(o.s = 85);
}({
  1: function _(e, t) {
    e.exports = require("react");
  },
  10: function _(e, t) {
    e.exports = require("../../styles/breakpoints");
  },
  2: function _(e, t) {
    e.exports = require("styled-components");
  },
  3: function _(e, t) {
    e.exports = require("../../styles");
  },
  5: function _(e, t) {
    e.exports = require("../Icon/Icon");
  },
  85: function _(e, t, o) {
    "use strict";

    var r = this && this.__importStar || function (e) {
      if (e && e.__esModule) return e;
      var t = {};
      if (null != e) for (var o in e) {
        Object.hasOwnProperty.call(e, o) && (t[o] = e[o]);
      }
      return t.default = e, t;
    },
        n = this && this.__importDefault || function (e) {
      return e && e.__esModule ? e : {
        default: e
      };
    };

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = r(o(1)),
        l = n(o(2)),
        a = n(o(5)),
        d = n(o(10)),
        s = o(3),
        _s$colorPalettes = s.colorPalettes,
        c = _s$colorPalettes.MiscPalette,
        u = _s$colorPalettes.KineduPalette,
        p = l.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  border-radius: 5px;\n  bottom: 5px;\n  left: 50%;\n  min-width: 95%;\n  padding: 5px;\n  position: fixed;\n  transform: translateX(-50%);\n\n  ", " {\n    background-color: ", ";\n    bottom: initial;\n    display: none;\n    font-size: 12px;\n    font-weight: 325;\n    left: initial;\n    line-height: 16px;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n\n    ::before,\n    ::after {\n      border-bottom: 8px solid transparent;\n      border-right-style: solid;\n      border-right-width: 14px;\n      border-top: 8px solid transparent;\n      content: \"\";\n      display: block;\n      height: 0;\n      left: -14px;\n      position: absolute;\n      top: 50%;\n      transform: translateY(-50%);\n      width: 0;\n    }\n\n    ::after {\n      border-right-color: white;\n      left: -12px;\n    }\n  }\n"])), d.default.desktop, c.white),
        f = l.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  border-radius: 50%;\n  border: 1px solid ", ";\n  cursor: pointer;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  height: ", ";\n  margin: 5px;\n  position: relative;\n  width: ", ";\n  background-color: ", ";\n\n  .Tooltip-icon * {\n    stroke: none;\n  }\n\n  ", " {\n    border: 1px solid ", ";\n    color: ", ";\n    right: ", ";\n    width: ", ";\n\n    ::before {\n      border-right-color: ", ";\n    }\n  }\n\n  ", " {\n    display: ", ";\n  }\n\n  ", " {\n    ", " {\n      display: none;\n    }\n    &:hover ", " {\n      display: block !important;\n    }\n  }\n\n  ", "\n"])), function (_ref) {
      var e = _ref.color;
      return e || u.shadeMediumLight;
    }, function (_ref2) {
      var e = _ref2.width;
      return e || "24px";
    }, function (_ref3) {
      var e = _ref3.width;
      return e || "24px";
    }, function (_ref4) {
      var e = _ref4.bgColor;
      return e || u.shadeMediumLight;
    }, p, function (_ref5) {
      var e = _ref5.color;
      return e || u.shadeMediumLight;
    }, function (_ref6) {
      var e = _ref6.colorText;
      return e || u.shadeDark;
    }, function (_ref7) {
      var e = _ref7.widthContent;
      return "calc((".concat(e, " + 25px) * -1)") || "-229px";
    }, function (_ref8) {
      var e = _ref8.widthContent;
      return e || "204px";
    }, function (_ref9) {
      var e = _ref9.color;
      return e || u.shadeMediumLight;
    }, p, function (_ref10) {
      var e = _ref10.active;
      return e ? "block" : "none";
    }, d.default.desktop, p, p, function (_ref11) {
      var e = _ref11.disabled;
      return e && "pointer-events: none; opacity: .5";
    });

    t.default = function (_ref12) {
      var e = _ref12.classNames,
          t = _ref12.color,
          o = _ref12.colorText,
          r = _ref12.disabled,
          n = _ref12.icon,
          l = _ref12.iconColor,
          d = _ref12.onClick,
          s = _ref12.text,
          c = _ref12.width,
          b = _ref12.widthContent,
          h = _ref12.bgColor;

      var _i$useState = i.useState(!1),
          _i$useState2 = _slicedToArray(_i$useState, 2),
          x = _i$useState2[0],
          m = _i$useState2[1],
          g = function g() {
        x && m && m(!1);
      };

      return i.useEffect(function () {
        return document.addEventListener("click", g), function () {
          document.removeEventListener("click", g);
        };
      }), i.default.createElement(f, {
        className: e || "Tooltip",
        color: t,
        bgColor: h,
        colorText: o,
        disabled: r,
        onClick: function onClick() {
          return m(!x), d && d(), x;
        },
        width: c,
        widthContent: b,
        active: x
      }, i.default.createElement(a.default, {
        name: n || "exclamation",
        size: 20,
        className: "Tooltip-icon",
        color: l || u.shadeDark
      }), s ? i.default.createElement(p, null, s) : null);
    };
  }
});